// extracted by mini-css-extract-plugin
export var btn = "styles-module__btn___q__GY";
export var form = "styles-module__form___hpvNC";
export var icon = "styles-module__icon___YazfS";
export var input = "styles-module__input___Kdy1s";